export default __webpack_public_path__ + "static/media/start_end.2691cca2.mp3";